import React from "react";
import Profile from '../asset/profile.jpeg';
import Reactjs from '../asset/react.png';
import Uiux from '../asset/uiux.png';
import Nodejs from '../asset/nodejs.png';

const About = () => {
    return(
        <section id="about" className="py-5 bg-color2 ">
            <div className="container mx-auto text-center px-6">
                <h2 className="text-4xl font-bold mb-8 text-white">
                    Tentang Saya
                </h2>

                <div className="flex flex-col items-center mb-12">
                    <img src={Profile} alt="Profile Picture" className="w-32 h-32 rounded-full object-cover mb-4 shadow-lg opacity-70 border-4 border-white"/>
                    <p className="text-xl text-white mb-2 font-semibold">KiDi Intern</p>
                    <p className="text-lg text-white">I’m an software engginner intern in KiDi Telkom Eduorse</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    <div className="bg-color1 p-6 rounded-lg hover:bg-color3 transition-colors shadow-glow2 duration-100 ">
                        <h3 className="text-2xl font-bold mb-4 text-white">ReactJS</h3>
                        <img src={Reactjs} className="mx-auto items-center"/>
                        <p className="text-white mb-4 ">
                            ReactJS adalah pustaka JavaScript yang digunakan untuk 
                            membangun antarmuka pengguna, terutama untuk aplikasi web. 
                            Dikenal karena kemampuannya untuk membuat komponen UI yang 
                            dapat digunakan kembali, React memungkinkan pengembang 
                            untuk mengelola keadaan aplikasi dengan efisien dan mempercepat 
                            proses pengembangan. Dengan konsep "virtual DOM", React dapat 
                            memperbarui tampilan aplikasi dengan 
                            lebih cepat dan responsif..
                        </p>
                    </div>
                    
                    <div className="bg-color1 p-6 rounded-lg hover:bg-color3 transition-colors shadow-glow2 duration-100">
                        <h3 className="text-2xl font-bold mb-4 text-white">UI/UX</h3>
                        <img src={`${Uiux}`} className="mx-auto items-center"/>
                        <p className="text-white mb-4 ">
                            UI (User Interface) adalah desain visual dan elemen interaktif 
                            dari antarmuka pengguna, seperti tombol dan layout. UX 
                            (User Experience) adalah pengalaman keseluruhan pengguna saat 
                            berinteraksi dengan produk, mencakup kenyamanan dan kepuasan. 
                            Keduanya penting untuk menciptakan produk yang menarik dan
                            mudah digunakan.
                        </p>
                    </div>

                    <div className="bg-color1 p-6 rounded-lg hover:bg-color3 transition-colors shadow-glow2  duration-100">
                        <h3 className="text-2xl font-bold mb-4 text-white">NodeJS</h3>
                        <img src={`${Nodejs}`} className="mx-auto items-center"/>
                        <p className="text-white mb-4 ">
                            Node.js adalah lingkungan runtime JavaScript yang memungkinkan 
                            pengembang menjalankan kode JavaScript di sisi server. Dikenal 
                            karena kinerjanya yang cepat dan kemampuannya untuk menangani 
                            banyak koneksi secara bersamaan, Node.js menggunakan model 
                            berbasis event dan non-blocking I/O. Ini ideal untuk membangun 
                            aplikasi web real-time dan layanan backend yang efisien.
                        </p>
                    </div>
                </div>
                <p className="text-lg text-white mt-8">
                    
                </p>
            </div>
        </section>
    )
}

export default About;